export const ARCHIVE_FILENAME = 'Archive';
export const ARCHIVE_FILE_TYPE = 'Archive File Type';
export const EXPORT_FILE_TYPE = 'Export File Type';
export const PROGRESS_BAR_WIDTH = '90%';
export const IS_SELECTED = 'Y';
export const IS_NOT_SELECTED = 'N';
export const IS_SELECTED_FIELD_NAME = 'isSelectedForExport';
export const IS_SELECTED_ROW_NAME = 'isSelected';
export const LOADING = 'loading';
